import { SurveyQuestionComment } from 'survey-react-ui';
import { invoke } from 'lodash';
import classNames from 'classnames';
import { IonTextarea } from '@ionic/react';

import inputStyles from '../../Form/_styles/input.module.scss';
import formControlStyles from '../../Form/FormControl/FormControl.module.scss';

export class SurveyComment extends SurveyQuestionComment {
  public renderElement = () => {
    const invalid = this.question.errors.some(({ visible }) => visible);

    const onInput = (event: any) => {
      if (this.question.isInputTextUpdate) {
        this.updateValueOnEvent(event);
      } else {
        this.question?.updateElement();
      }

      const newValue = event.target.value;
      this.question.updateRemainingCharacterCounter(newValue);
    };

    const onBlur = (e: any): void => {
      if (!this.question.isInputTextUpdate) {
        this.updateValueOnEvent(e);
      }
      this.question.onBlur(e);
    };

    return (
      <div className={formControlStyles.default} style={{ width: '100%' }}>
        <IonTextarea
          fill="outline"
          name={this.question.name}
          label={this.question.title}
          labelPlacement="stacked"
          id={this.question.inputId}
          disabled={this.question.isDisabledAttr}
          readonly={this.question.isReadOnlyAttr}
          ref={(textarea) => this.setControl(textarea)}
          maxlength={this.question.getMaxLength()}
          placeholder={this.question.renderedPlaceholder}
          onFocus={(event) => this.question.onFocus(event)}
          onIonBlur={onBlur}
          onIonInput={onInput}
          onKeyDown={(event) => this.question.onKeyDown(event)}
          counter={this.question.maxLength !== -1}
          cols={this.question.cols}
          rows={this.question.rows}
          style={{ resize: this.question.resizeStyle }}
          autoGrow
          helperText={this.question.description}
          errorText={invoke(this.question, ['errors', 0, 'getText'])}
          className={classNames(inputStyles.root, {
            'ion-invalid': invalid,
            'ion-touched': invalid,
          })}
        />
      </div>
    );
  };
}
